var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { load, loadLast } from "framework/state/loader";
import { addMonths } from "framework/state/types";
import { NoEntityError, updateByEntityResponse } from "framework/validation/validatableentity";
import { updateByCollectionResponse } from "framework/state/collection";
import { apiGetEvent, apiGetEvents } from "../endpoint";
import { EventType } from "../entity";
import { getIsoStringDate } from "framework/helpers";
import { setEntityField } from "framework/state/setfield";
var DetailPage;
(function (DetailPage) {
    DetailPage[DetailPage["None"] = 0] = "None";
    DetailPage[DetailPage["Competitions"] = 1] = "Competitions";
    DetailPage[DetailPage["Propositions"] = 2] = "Propositions";
    DetailPage[DetailPage["Competitors"] = 3] = "Competitors";
    DetailPage[DetailPage["Registration"] = 4] = "Registration";
    DetailPage[DetailPage["Officials"] = 5] = "Officials";
})(DetailPage || (DetailPage = {}));
var detailPageDictionary = {
    '': DetailPage.None,
    'souteze': DetailPage.Competitions,
    'propozice': DetailPage.Propositions,
    'soutezici': DetailPage.Competitors,
    'prihlaseni': DetailPage.Registration,
    'funkcionari': DetailPage.Officials,
};
export var detailPageToString = function (val) {
    for (var _i = 0, _a = Object.entries(detailPageDictionary); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (val === value) {
            return key;
        }
    }
    return '';
};
export var detailPageFromString = function (val) {
    for (var _i = 0, _a = Object.entries(detailPageDictionary); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (val === key) {
            return value;
        }
    }
    return DetailPage.None;
};
var FilterStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: {
        fromDate: new Date(),
        toDate: addMonths(new Date(), 3),
        region: "0",
        class: "0",
        age: "0",
        discipline: "0",
        series: "0",
        type: "0",
    }, errors: __assign({}, NoEntityError), addOneMonthIndicator: 0 });
var SelectedEventStateDefaults = __assign(__assign({}, LoadingStateDefaults), { errors: __assign({}, NoEntityError), entity: null });
var EventsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { errors: __assign({}, NoEntityError), collection: [] });
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { selected_event_state: SelectedEventStateDefaults, events_state: EventsStateDefaults, events: {}, detailPage: DetailPage.None, filter_state: FilterStateDefaults, filterSeries: [], filterAges: [], filterClasses: [], filterDisciplines: [], filterTypes: [], scrollIntoView: false });
var formatEventList = function (events, succeeded) {
    var result = {};
    function sortByMonthsAsc(dict) {
        var sorted = [];
        for (var key in dict) {
            sorted[sorted.length] = key;
        }
        sorted.sort();
        var tempDict = {};
        for (var i = 0; i < sorted.length; i++) {
            tempDict[sorted[i]] = dict[sorted[i]];
        }
        return tempDict;
    }
    if (succeeded) {
        events.forEach(function (e) { return e.eventCompetitions.forEach(function (c) {
            var key = getIsoStringDate(c.date).substring(0, 7);
            var items = result[key];
            if (items == null) {
                items = [];
                result[key] = items;
            }
            var itemType = EventType.Competition;
            var itemId = c.id;
            items.push(__assign(__assign({}, c), { key_: "".concat(itemType, "-").concat(itemId), type_: itemType, eventId: e.id }));
        }); });
        Object.keys(result).forEach(function (k) {
            result[k] = result[k].sort(function (a, b) { return a.date.getTime() - b.date.getTime(); });
        });
    }
    result = sortByMonthsAsc(result);
    return result;
};
var setFilterEntityField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.filter_state, field, value, validator, storeInvalidValue);
    });
}; };
var addOneMonth = function () { return function (store) {
    store.setState(function (draft) {
        draft.filter_state.entity.toDate = addMonths(draft.filter_state.entity.toDate, 1);
        draft.filter_state.addOneMonthIndicator += 1;
    });
}; };
var getAllEventItems = function (eventDictionary) {
    var result = [];
    for (var _i = 0, _a = Object.entries(eventDictionary); _i < _a.length; _i++) {
        var _b = _a[_i], _ = _b[0], eventItemArray = _b[1];
        eventItemArray.forEach(function (item) { return result.push(item); });
    }
    return result;
};
var loadEvents = function (store, filter) {
    var loader = function () { return apiGetEvents(filter); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.events_state, response);
            draft.events = formatEventList(draft.events_state.collection, response.succeeded);
        });
    };
    loadLast(store, loader, stateProducer, function (s) { return s.events_state; });
};
var adjustFilterDateRange = function (draft) {
    var _a, _b;
    if (((_a = draft.selected_event_state.entity) === null || _a === void 0 ? void 0 : _a.dateTo) && ((_b = draft.selected_event_state.entity) === null || _b === void 0 ? void 0 : _b.dateFrom)) {
        if (draft.filter_state.entity.toDate < draft.selected_event_state.entity.dateTo) {
            draft.filter_state.entity.toDate = draft.selected_event_state.entity.dateTo;
        }
        if (draft.filter_state.entity.fromDate > draft.selected_event_state.entity.dateFrom) {
            draft.filter_state.entity.fromDate = draft.selected_event_state.entity.dateFrom;
        }
    }
};
// this loads given event which is possibly not present in the list, in which case it adjusts the date range of the filter
var loadSelectedEventAndAdjustFilterDateRange = function (eventId) { return function (store) {
    var loader = function () { return apiGetEvent(eventId); };
    var stateProducer = function (store, _, response) {
        var filter_entity_json = JSON.stringify(store.getState().filter_state.entity);
        store.setState(function (draft) {
            updateByEntityResponse(draft.selected_event_state, response);
            adjustFilterDateRange(draft);
        });
        if (filter_entity_json !== JSON.stringify(store.getState().filter_state.entity)) {
            store.dispatch(applyFilter());
        }
    };
    load(store, loader, stateProducer, function (s) { return s.selected_event_state; });
}; };
var showDetailPage = function (detailPage, eventId, eventCompetitionId) { return function (store) {
    var state = store.getState();
    var item = null;
    var allItems = getAllEventItems(state.events);
    if (detailPage !== DetailPage.None) {
        item = allItems.find(function (i) { return i.eventId === eventId && i.id === eventCompetitionId; }) || null;
    }
    if (state.selectedEventItem !== item) {
        store.setState(function (draft) {
            if (state.selectedEventItem !== null) {
                draft.scrollIntoView = true;
            }
            draft.selectedEventItem = item;
        });
    }
    if (state.detailPage !== detailPage) {
        store.setState(function (draft) {
            draft.detailPage = detailPage;
        });
    }
}; };
var hideDetailPage = function () { return function (store) {
    store.setState(function (draft) {
        draft.selectedEventItem = null;
        draft.detailPage = DetailPage.None;
    });
}; };
var setFilterCollections = function (series, ages, classes, disciplines, types) { return function (store) {
    store.setState(function (draft) {
        var all = { id: 0, name: '- všechny -', order: 0, code: null };
        draft.filterSeries = [all].concat(series);
        draft.filterAges = [all].concat(ages);
        draft.filterClasses = [all].concat(classes);
        draft.filterDisciplines = [all].concat(disciplines);
        draft.filterTypes = [all].concat(types);
    });
}; };
var applyFilter = function () { return function (store) {
    var _a = store.getState().filter_state.entity, fromDate = _a.fromDate, toDate = _a.toDate, fp = __rest(_a, ["fromDate", "toDate"]);
    var fields = [
        //`state IN(${EventState.Ready}, ${EventState.Canceled})`,
        "date>=" + getIsoStringDate(fromDate).substring(0, 10),
        "date<=" + getIsoStringDate(toDate).substring(0, 10),
    ];
    Object.entries(fp).filter(function (v) { return v[1] !== "0"; }).map(function (v) { return fields.push("".concat(v[0], "=").concat(v[1])); });
    var filter = fields.join(" AND ");
    loadEvents(store, filter);
}; };
var setScrollIntoView = function (value) { return function (store) {
    store.setState(function (draft) {
        draft.scrollIntoView = value;
    });
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        applyFilter: applyFilter,
        showDetailPage: showDetailPage,
        hideDetailPage: hideDetailPage,
        setFilterCollections: setFilterCollections,
        addOneMonth: addOneMonth,
        setFilterEntityField: setFilterEntityField,
        loadSelectedEventAndAdjustFilterDateRange: loadSelectedEventAndAdjustFilterDateRange,
        setScrollIntoView: setScrollIntoView,
    },
    name: "EventCalendarList"
});
var useState = createHook(store);
export { DetailPage, StateDefaults as EventCalendarListDefaults, useState as useEventCalendarList, };
